import React from 'react';
import { CoreContainer } from '@hub/core-container';
import { Text } from '@hub/text';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { H3 } from '@hub/heading';
import { Button } from '@hub/button';
import { Link } from '@hub/link';
import { PhoneMediumIcon, WebsiteMediumIcon, LocationDropPinMediumIcon, ParkingMediumIcon, InfoConciergeMediumIcon, HoursMediumIcon, GiftCardsMediumIcon } from '@hub/icon';
import { Grid } from '@hub/grid';
import UtilityBoxOpeningHours from '../../components/utility-box-opening-hours';
import { storeIsOpen } from '../../helpers/store-helper';
import { parseStoreHours } from '../../helpers/parse-opening-hours';
import getStoreMapLink from '../../helpers/get-store-map-link';
import { isDefinedAndNotNull } from '../../lib';
import { CloudinaryImage, IMAGE_SIZES_HERO } from '../cloudinary-image';
import getGiftcardUrl from '../../helpers/get-giftcard-url';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const StorefrontUtility = _ref => {
  var _store$paymentMethods, _callsToActionCollect;
  let {
    centre,
    centreTradingSchedule,
    store,
    storeTradingSchedule,
    disablePadding = false,
    enableH1Heading
  } = _ref;
  const {
    title,
    telephoneNumber,
    websiteAddress,
    physicalAddress,
    landmarkDescription,
    parkingInstructions,
    services,
    callsToActionCollection,
    storeFrontImage,
    status,
    retailer
  } = store;
  const parsedOpeningHours = storeIsOpen(status) && storeTradingSchedule && centreTradingSchedule && (centre === null || centre === void 0 ? void 0 : centre.timeZone) && parseStoreHours(storeTradingSchedule, centreTradingSchedule, centre.timeZone);
  const storeMapLink = getStoreMapLink(centre, store);
  const centreTitle = centre.title;
  const paymentMethodsArr = store.paymentMethods && ((_store$paymentMethods = store.paymentMethods) === null || _store$paymentMethods === void 0 ? void 0 : _store$paymentMethods.length) > 0 ? store.paymentMethods : retailer.paymentMethods;
  const paymentMethods = [...(paymentMethodsArr !== null && paymentMethodsArr !== void 0 ? paymentMethodsArr : [])].filter(isDefinedAndNotNull);
  const paymentMethodsIndexOfWGC = paymentMethods.indexOf('Westfield Giftcard');
  const acceptsWestfieldGiftcard = paymentMethodsIndexOfWGC !== -1;
  if (paymentMethodsIndexOfWGC !== -1) {
    paymentMethods.splice(paymentMethodsIndexOfWGC, 1);
  }
  const callsToAction = (_callsToActionCollect = callsToActionCollection === null || callsToActionCollection === void 0 ? void 0 : callsToActionCollection.items) !== null && _callsToActionCollect !== void 0 ? _callsToActionCollect : [];
  const website = websiteAddress || retailer.websiteAddress;
  return /*#__PURE__*/_jsx(CoreContainer, {
    isMobileFullWidth: true,
    "data-id": "storefront-utility_index_StorefrontUtility_CoreContainer",
    children: /*#__PURE__*/_jsxs(Stack, {
      direction: ['column', 'column', 'row'],
      gap: "spacing-5",
      shouldWrapChildren: false,
      sx: {
        alignItems: ['left', 'left', 'top'],
        padding: disablePadding ? 0 : ['spacing-md', 'spacing-md', 'spacing-sm'],
        justifyContent: 'space-between'
      },
      flexBasis: 0,
      "data-id": "storefront-utility_index_StorefrontUtility_CoreContainer_Stack",
      children: [/*#__PURE__*/_jsxs(Stack, {
        sx: {
          maxWidth: [undefined, undefined, '610px']
        },
        gap: "spacing-md",
        shouldWrapChildren: false,
        "data-id": "storefront-utility_index_StorefrontUtility_Stack_Stack_2",
        children: [/*#__PURE__*/_jsxs(H3, {
          as: enableH1Heading ? 'h1' : 'h3',
          align: ['center', 'center', 'left'],
          "data-id": "storefront-utility_index_StorefrontUtility_Stack_H3",
          children: ["Visit ", title, " at ", centreTitle]
        }), /*#__PURE__*/_jsxs(Stack, {
          direction: ['row', 'row', 'column', 'column'],
          maxWidth: 'size-21',
          "data-id": "storefront-utility_index_StorefrontUtility_Stack_Stack",
          children: [!storeIsOpen(status) && /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Box",
            children: [/*#__PURE__*/_jsx(HoursMediumIcon, {
              boxSize: "size-icon-md",
              "aria-label": "Hours icon",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_HoursMediumIcon"
            }), /*#__PURE__*/_jsx(Text, {
              sx: {
                marginLeft: 'spacing-md'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Box_Text",
              children: status
            })]
          }), storeIsOpen(status) && /*#__PURE__*/_jsx(Box, {
            sx: {
              width: 'size-full'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Box",
            children: parsedOpeningHours && /*#__PURE__*/_jsx(UtilityBoxOpeningHours, {
              withinV2Design: true,
              wrapperNoBorder: true,
              headerNoPadding: true,
              openingHours: parsedOpeningHours,
              "data-id": "storefront-utility_index_StorefrontUtility_UtilityBoxOpeningHours"
            })
          })]
        }), (landmarkDescription || physicalAddress) && /*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          shouldWrapChildren: false,
          "data-id": "storefront-utility_index_StorefrontUtility_Stack",
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              flexGrow: 0
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Stack_Box",
            children: /*#__PURE__*/_jsx(LocationDropPinMediumIcon, {
              sx: {
                marginRight: 'spacing-md'
              },
              boxSize: "size-icon-md",
              ariaLabel: "location drop pin icon",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_LocationDropPinMediumIcon"
            })
          }), /*#__PURE__*/_jsxs(Stack, {
            direction: "column",
            shouldWrapChildren: false,
            sx: {
              flexGrow: 1
            },
            gap: 'spacing-sm',
            "data-id": "storefront-utility_index_StorefrontUtility_Stack_Stack",
            children: [/*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'inline'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Stack_Box",
              children: [physicalAddress && "".concat(physicalAddress, ","), ' ', landmarkDescription]
            }), /*#__PURE__*/_jsx(Box, {
              "data-id": "storefront-utility_index_StorefrontUtility_Stack_Box_15",
              children: storeMapLink && /*#__PURE__*/_jsx(Link, {
                hasUnderline: true,
                isExternal: true,
                href: storeMapLink,
                "data-id": "storefront-utility_index_StorefrontUtility_Link",
                children: "See on centre map"
              })
            })]
          })]
        }), parkingInstructions && /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            alignItems: 'center'
          },
          "data-id": "storefront-utility_index_StorefrontUtility_Box",
          children: [/*#__PURE__*/_jsx(ParkingMediumIcon, {
            boxSize: "size-icon-md",
            ariaLabel: "Parking icon",
            "data-id": "storefront-utility_index_StorefrontUtility_Box_ParkingMediumIcon"
          }), /*#__PURE__*/_jsx(Text, {
            sx: {
              marginLeft: 'spacing-md'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Box_Text",
            children: parkingInstructions
          })]
        }), acceptsWestfieldGiftcard && /*#__PURE__*/_jsx(Stack, {
          gap: "spacing-sm",
          "data-id": "storefront-utility_index_StorefrontUtility_Stack",
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Stack_Box",
            children: [/*#__PURE__*/_jsx(GiftCardsMediumIcon, {
              boxSize: "size-icon-md",
              ariaLabel: "Gift card icon",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_GiftCardsMediumIcon"
            }), /*#__PURE__*/_jsx(Box, {
              sx: {
                marginLeft: 'spacing-md'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Box_Box",
              children: /*#__PURE__*/_jsx(Link, {
                hasUnderline: true,
                isExternal: centre.country === 'New Zealand',
                href: getGiftcardUrl(centre.country),
                "data-id": "storefront-utility_index_StorefrontUtility_Box_Link",
                children: "Accepts Westfield Gift Cards"
              })
            })]
          })
        }), (telephoneNumber || websiteAddress) && /*#__PURE__*/_jsxs(Stack, {
          direction: ['column', 'column', 'row', 'row'],
          gap: ['spacing-md', 'spacing-md', 'spacing-11', 'spacing-11'],
          "data-id": "storefront-utility_index_StorefrontUtility_Stack",
          children: [telephoneNumber && /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Box",
            children: [/*#__PURE__*/_jsx(PhoneMediumIcon, {
              boxSize: "size-icon-md",
              ariaLabel: "phone icon",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_PhoneMediumIcon"
            }), /*#__PURE__*/_jsx(Link, {
              hasUnderline: true,
              isExternal: true,
              href: "tel:".concat(telephoneNumber),
              sx: {
                marginLeft: 'spacing-md'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Box_Link",
              children: telephoneNumber
            })]
          }), website && /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Box",
            children: [/*#__PURE__*/_jsx(WebsiteMediumIcon, {
              boxSize: "size-icon-md",
              ariaLabel: "website icon",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_WebsiteMediumIcon"
            }), /*#__PURE__*/_jsx(Link, {
              hasUnderline: true,
              isExternal: true,
              href: website,
              sx: {
                marginLeft: 'spacing-md'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Box_Link",
              children: "Website"
            })]
          })]
        }), (services === null || services === void 0 ? void 0 : services.length) && /*#__PURE__*/_jsx(Stack, {
          gap: "spacing-sm",
          shouldWrapChildren: false,
          "data-id": "storefront-utility_index_StorefrontUtility_Stack",
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex'
            },
            "data-id": "storefront-utility_index_StorefrontUtility_Stack_Box",
            children: [/*#__PURE__*/_jsx(InfoConciergeMediumIcon, {
              boxSize: "size-icon-md",
              "data-id": "storefront-utility_index_StorefrontUtility_Box_InfoConciergeMediumIcon"
            }), /*#__PURE__*/_jsx(Text, {
              sx: {
                marginLeft: 'spacing-md'
              },
              "data-id": "storefront-utility_index_StorefrontUtility_Box_Text",
              children: services.join(', ')
            })]
          })
        }), callsToAction.length > 0 && /*#__PURE__*/_jsx(Grid, {
          templateColumns: ['repeat(auto-fit, 100%)', 'repeat(auto-fit, 100%)', 'repeat(auto-fit, 50%)', 'repeat(auto-fit, 49%)'],
          direction: ['column', 'column', 'row'],
          gap: 'spacing-sm',
          shouldWrapChildren: false,
          sx: {
            paddingTop: 'spacing-sm'
          },
          "data-id": "storefront-utility_index_StorefrontUtility_Grid",
          children: callsToAction.map((callToActionBtn, index) => {
            const {
              category,
              address
            } = callToActionBtn || {};
            return category && address && /*#__PURE__*/_jsx(Button, {
              sx: {
                minWidth: 'size-xl'
              },
              variant: "outline",
              colorScheme: "licorice",
              onClick: () => window.open(address, '_blank'),
              "data-id": "storefront-utility_index_StorefrontUtility_Button",
              children: category
            }, index);
          })
        })]
      }), storeFrontImage && /*#__PURE__*/_jsx(Stack, {
        sx: {
          display: 'flex',
          maxWidth: [undefined, undefined, 'size-22']
        },
        "data-id": "storefront-utility_index_StorefrontUtility_Stack",
        children: /*#__PURE__*/_jsx(CloudinaryImage, {
          ratio: "3/2",
          imageSetOrImage: {
            type: 'WIDE',
            url: storeFrontImage,
            alt: "".concat(title, " storefront image")
          },
          "aria-labelledby": title,
          sizes: IMAGE_SIZES_HERO,
          "data-id": "storefront-utility_index_StorefrontUtility_Stack_CloudinaryImage"
        })
      })]
    })
  });
};